/**
 * getAuthToken — Returns the correct token based on the current route.
 */
export const getAuthToken = () => {
  if (window.location.pathname.startsWith('/partner')) {
    return localStorage.getItem('partner_access_token');
  }
  if (window.location.pathname.startsWith('/admin')) {
    return localStorage.getItem('admin_access_token');
  }
  return localStorage.getItem('user_access_token');
};

/**
 * getRefreshToken — Returns the correct refresh token based on the current route.
 */
export const getRefreshToken = () => {
  if (window.location.pathname.startsWith('/partner')) {
    return localStorage.getItem('partner_refresh_token');
  }
  if (window.location.pathname.startsWith('/admin')) {
    return localStorage.getItem('admin_refresh_token');
  }
  return localStorage.getItem('user_refresh_token');
};

/**
 * setTokens — Sets both tokens for a specific role
 */
export const setTokens = (role, access, refresh) => {
  if (!access) return;

  if (role === 'partner') {
    localStorage.setItem('partner_access_token', access);
    localStorage.setItem('partner_refresh_token', refresh);
  } else if (role === 'admin') {
    localStorage.setItem('admin_access_token', access);
    localStorage.setItem('admin_refresh_token', refresh);
  } else {
    localStorage.setItem('user_access_token', access);
    localStorage.setItem('user_refresh_token', refresh);
  }
};

/**
 * clearTokens — Clears tokens for a specific role
 */
export const clearTokens = (role) => {
  if (role === 'partner') {
    localStorage.removeItem('partner_access_token');
    localStorage.removeItem('partner_refresh_token');
    localStorage.removeItem('partnerUser');
  } else if (role === 'admin') {
    localStorage.removeItem('admin_access_token');
    localStorage.removeItem('admin_refresh_token');
    localStorage.removeItem('adminUser');
  } else {
    localStorage.removeItem('user_access_token');
    localStorage.removeItem('user_refresh_token');
    localStorage.removeItem('loggedUser');
  }
};

/**
 * getAuthUser — Returns the stored user object for the current role.
 */
export const getAuthUser = () => {
  if (window.location.pathname.startsWith('/partner')) {
    const u = localStorage.getItem('partnerUser');
    return u ? JSON.parse(u) : null;
  }
  if (window.location.pathname.startsWith('/admin')) {
    const u = localStorage.getItem('adminUser');
    return u ? JSON.parse(u) : null;
  }
  const u = localStorage.getItem('loggedUser');
  return u ? JSON.parse(u) : null;
};

/**
 * isPartnerRoute — Returns true if currently on a /partner/* path.
 */
export const isPartnerRoute = () => window.location.pathname.startsWith('/partner');

/**
 * isAdminUser — Returns true if the current token belongs to an admin (not partner).
 */
export const isAdminUser = () => !!localStorage.getItem('admin_access_token') && !isPartnerRoute();
